import { render, staticRenderFns } from "./DownloadVhcReport.vue?vue&type=template&id=1c0489ce"
import script from "./DownloadVhcReport.vue?vue&type=script&lang=js"
export * from "./DownloadVhcReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports